<style lang="less">
.order-view {
  h3 {
    text-indent: 10px;
    line-height: 50px;
    border-bottom: 1px solid #eee;
    font-size: 16px;
    color: #333;
  }
  .block {
    padding: 20px 0;
    background: #fff;
  }
  .yd-list-title {
    height: auto !important;
  }
  .yd-list-item {
    border-bottom: 1px solid #eee;
    padding: 20px 0;
    &:last-child {
      border-bottom-width: 0;
    }
  }

  .yd-preview-item>:first-child {
    text-align-last:left;
  }
  .yd-list-mes {
    display: flex;
    padding: 10px 0;
    padding-left: 20px;
    flex-direction: column;
    justify-content: space-between;
  }
  .yd-list-other {
    height: auto;
    .flex-col,
    .cartitem-line {
      width: 100%;
      padding-right: 10px;
    }
  }
  .item-title {
    font-size: 14px;
    font-weight: bold;
    color: #505050;
  }
  .yd-preview-item {
    color: #666;
  }
}
.scan-tip {
  font-size: 14px;
  color: "#666";
  padding: 20px;
  line-height: 2;
}

.scan-row {
  padding: 30px 0;
  display: flex;
  flex-direction: row;
  justify-content: space-around;
}

.track-list ul {
  padding: 0;
  margin: 0;
}

.track-list li div {
  padding-left: 5px;
}

.track-list ul {
  padding: 0;
  margin: 0;
}

.track-list {
  height: 300px;
  //  margin-left: 20px;
  overflow: scroll;
  text-align: left;
}
.track-list li:before {
  content: "";
  border: 3px solid #f3f3f3;
  background-color: #d9d9d9;
  display: inline-block;
  width: 5px;
  height: 5px;
  border-radius: 5px;
  margin-left: -6px;
  margin-right: 10px;
}
.shipping-status-wrapper {
  text-align: center;
  background: #f3f3f3;
  padding: 10px;
}
</style>

<template>
  <div
    class="order-view wrap"
    v-if="order"
  >
    <h3>{{ order.sn }}</h3>
    <div
      class="block"
      style="margin-top: 0; padding: 25px 0"
      v-if="!cancelled"
    >
      <yd-step
        theme="1"
        :current="orderStep"
      >
        <yd-step-item>
          <span slot="bottom">提交订单</span>
        </yd-step-item>
        <yd-step-item>
          <span
            slot="bottom"
            v-if="paid"
          >已支付</span>
          <span
            slot="bottom"
            v-else
          >等待支付</span>
        </yd-step-item>
        <yd-step-item>
          <span slot="bottom">等待发货</span>
        </yd-step-item>
        <yd-step-item>
          <span slot="bottom">已发货</span>
        </yd-step-item>
      </yd-step>
    </div>
    <div
      class="block"
      style="margin-top: 0; padding: 25px 0"
      v-else
    >
      <yd-step
        theme="1"
        current="3"
      >
        <yd-step-item>
          <span slot="bottom">提交订单</span>
        </yd-step-item>
        <yd-step-item>
          <span
            slot="bottom"
            v-if="paid"
          >已支付</span>
          <span
            slot="bottom"
            v-if="unpaid"
          >未支付</span>
          <span
            slot="bottom"
            v-if="refund"
          >已退款</span>
        </yd-step-item>
        <yd-step-item>
          <span slot="bottom">已取消</span>
        </yd-step-item>
      </yd-step>
    </div>
    <div
      class="block"
      style="padding: 10px"
    >
      <yd-list
        theme="4"
        class="product-list order-item-list"
      >
        <yd-list-item
          v-for="(item, key) in orderItems"
          :key="key"
        >
          <img
            slot="img"
            :src="item.photos[0]"
          />
          <span
            slot="title"
            class="item-title"
          >{{ item.name }}</span>
          <yd-list-other slot="other">
            <div class="flex-col">
              <div
                class="cartitem-line"
                v-if="item.color"
              >
                <span>颜色： {{ item.color }}</span>
              </div>
              <div
                class="cartitem-line"
                v-if="item.size"
              >
                <span>尺寸： {{ item.size }}</span>
              </div>
              <div
                class="cartitem-line flex-row flex-sb"
                style="margin-top: 5px"
              >
                <span class="price">
                  <em>¥</em>
                  {{ (item.sale_price / 100).toFixed(2) }}
                </span>
                <span style="font-size: 14px">{{ item.quantity }}件</span>
              </div>
            </div>
          </yd-list-other>
        </yd-list-item>
      </yd-list>
    </div>

    <div class="block">
      <yd-preview :buttons="[]">
        <yd-preview-item>
          <div slot="left">商品总金额</div>
          <div
            slot="right"
            class="price"
          >
            ¥{{ (order.goods_amount / 100).toFixed(2) }}
          </div>
        </yd-preview-item>
        <yd-preview-item>
          <div slot="left">运费</div>
          <div
            slot="right"
            class="price"
          >
            ¥{{ (order.shipping_amount / 100).toFixed(2) }}
          </div>
        </yd-preview-item>
         <yd-preview-item>
          <div slot="left">服务费</div>
          <div
            slot="right"
            class="price"
          >
            ¥{{ (order.tips / 100).toFixed(2) }}
          </div>
        </yd-preview-item>
        <yd-preview-item>
          <div slot="left">订单总金额</div>
          <div
            slot="right"
            class="price"
          >
            ¥{{ (order.order_amount / 100).toFixed(2) }}
          </div>
        </yd-preview-item>
      </yd-preview>
    </div>

    <div class="block">
      <yd-preview :buttons="[]">
        <yd-preview-item>
          <div slot="left">下单时间</div>
          <div slot="right">{{ order.created_at | moment }}</div>
        </yd-preview-item>
        <yd-preview-item>
          <div slot="left">订单状态</div>
          <div slot="right">
            {{ cancelled ? "已取消" : payDict[order.pay_status] }}
          </div>
        </yd-preview-item>
        <yd-preview-item>
          <div slot="left">配送状态</div>
          <div
            slot="right"
            class="normalText"
          >
            {{ goodsDict[order.goods_status] }}
          </div>
        </yd-preview-item>
        <yd-preview-item v-if="order.express_name">
          <div slot="left">物流信息</div>
          <div
            slot="right"
            @click="showShipping"
          >
            {{ order.express_name }} {{ order.express_number }}
            <yd-icon
              name="search"
              size="1rem"
              color="#FF685D"
            ></yd-icon>
          </div>
        </yd-preview-item>
        <yd-preview-item>
          <div slot="left">收货地址</div>
          <div slot="right">
            <p>{{ order.province }} {{ order.city }} {{ order.county }}</p>
            <p>{{ order.addr_detail }}</p>
          </div>
        </yd-preview-item>
        <yd-preview-item>
          <div slot="left">收货人</div>
          <div slot="right">{{ order.consignee }}</div>
        </yd-preview-item>
        <yd-preview-item>
          <div slot="left">联系电话</div>
          <div slot="right">{{ order.phone_number }}</div>
        </yd-preview-item>
        <yd-preview-item>
          <div slot="left">订单备注</div>
          <div
            slot="right"
            class="normalText"
          >
            {{ order.comment }}<a
              href="javascript:;"
              @click="displayChangeComment=true; originComment=order.comment"
            >[修改]</a>
          </div>
        </yd-preview-item>
      </yd-preview>
    </div>

    <yd-popup
      v-model="displayShpping"
      position="center"
      width="90%"
    >
      <div
        class="block shipping-status-wrapper"
        v-if="displayShpping"
      >
        <h2>配送状态</h2>
        <p v-if="shippingStatus.status!=200" style="padding:10px">运单查询失败，状态码为：{{shippingStatus.status}}</p>
        <ul class="track-list" v-if="shippingStatus.status==200">
          <li
            v-for="(c, index) in shippingStatus.msg.context"
            :key="index"
          >
            <div slot="left">{{ c.time }}</div>
            <div slot="right">{{ c.desc }}</div>
          </li>
        </ul>
        <yd-button @click.native="displayShpping = false">关闭</yd-button>
      </div>
    </yd-popup>

    <yd-popup
      v-model="displayChangeComment"
      position="center"
      width="80%"
    >
      <div
        class="block shipping-status-wrapper"
        v-if="displayChangeComment"
      >
        <h2>订单备注</h2>

        <yd-textarea
          slot="right"
          type="text"
          style="margin:10px"
          v-model="order.comment"
          placeholder="订单备注"
        />

        <yd-button style="margin-right:10px" @click.native="changeComment()">提交</yd-button>

        <yd-button
          @click.native="displayChangeComment = false; order.comment=originComment"
          type="hollow"
        >关闭</yd-button>
      </div>
    </yd-popup>
    <div v-if="!cancelled">
      <yd-button
        size="large"
        v-if="payEanbled"
        type="primary"
        @click.native="tapPay"
      >微信支付</yd-button>
      <!-- <yd-button
        size="large"
        v-if="cancelEnabled"
        type="danger"
        @click.native="tapCancel"
      >取消订单</yd-button> -->
    </div>

    <yd-popup
      v-model="showPayDialog"
      position="center"
    >
      <div class="wrap main-bg">
        <h3>请使用微信扫码支付</h3>
        <div class="scan-tip">
          <span class="price">由于微信限制，请在下单后15分钟之内付款、15分钟之后需取消订单重新下单。</span>
          <br />
          支付订单：{{ order.sn }} <br />支付金额：
          <span class="price">¥{{ (order.order_amount / 100).toFixed(2) }}</span>
          <br />收款主体：ARMADA
        </div>
        <div class="scan-row">
          <div>
            <div>
              <img :src="assets.scan2" />
            </div>
            <qrcode-vue
              style="margin-top: 20px"
              :value="codeUrl"
              :size="150"
              level="H"
            ></qrcode-vue>
          </div>
          <div>
            <img :src="assets.scan1" />
          </div>
        </div>
        <div style="padding: 50px">
          <yd-button
            style="margin: 0"
            size="large"
            type="primary"
            @click.native="checkPay"
          >已完成支付</yd-button>
        </div>
      </div>
    </yd-popup>
  </div>
</template>

<script>
import lodash from "lodash";
import moment from "moment";
import QrcodeVue from "qrcode.vue";
import { Alert } from "vue-ydui/dist/lib.rem/dialog";

const assets = {
  scan1: require("../assets/wxscan.png"),
  scan2: require("../assets/wxscan2.png")
};

export default {
  name: "order",

  components: {
    QrcodeVue
  },

  data: () => ({
    assets,
    order: null,
    displayShpping: false,
    shippingStatus: false,
    showPayDialog: false,
    displayChangeComment: false,
    codeUrl: ""
  }),

  computed: {
    // displayShpping() {
    //   console.log("shippingStatus", this.shippingStatus);
    //   return this.shippingStatus && this.shippingStatus.status == 200;
    // },
    orderItems() {
      return this.order ? this.order.items : [];
    },
    payDict() {
      return {
        PAID: "已支付",
        UNPAID: "未支付",
        ON_CREDIT: "赊账中"
      };
    },
    goodsDict() {
      return {
        UNSHIPPED: "未发货",
        SHIPPED: "已发货"
      };
    },
    cancelled() {
      return this.order.status == "CANCELLED";
    },
    paid() {
      return this.order.pay_status == "PAID";
    },
    unpaid() {
      return this.order.pay_status == "UNPAID";
    },
    refund() {
      return this.order.pay_status == "REFUND";
    },
    shipped() {
      return this.order.goods_status == "SHIPPED";
    },
    orderStep() {
      if (this.shipped) {
        return 4;
      }
      if (this.paid) {
        return 3;
      }
      return 2;
    },
    cancelEnabled() {
      const order = this.order;
      return order.status == "NORMAL" && order.goods_status != "SHIPPED";
    },
    payEanbled() {
      const order = this.order;
      return (order.pay_status == "UNPAID" || order.pay_status == "ON_CREDIT") && order.status == "NORMAL";
    }
  },
  filters: {
    moment: function (date) {
      return moment(date).add(8, "hours").format("YYYY-MM-DD HH:mm:ss");
    },
  },
  methods: {
    errorBack() {
      this.$dialog.alert({
        mes: "错误的访问方式",
        callback: () => this.$router.replace({ name: "home" })
      });
    },
    tapCancel() {
      this.$dialog.confirm({
        mes: "确定取消此订单？",
        opts: async () => {
          try {
            const order = await this.$store.dispatch(
              "order/cancel",
              this.order.id
            );
            if (order) {
              this.order.status = order.status;
              if (order.pay_status == "PAID") {
                this.$dialog.alert({
                  mes: "您的订单已成功取消，请联系客服为您办理退款事宜。"
                });
              } else {
                this.$dialog.toast({ mes: "订单已取消", icon: "success" });
              }
            }
          } catch (error) {
            this.$dialog.toast({
              mes: lodash.get(error, "response.data.message"),
              icon: "error"
            });
          }
        }
      });
    },
    async tapPay() {
      try {
        this.$dialog.loading.open("正在提交支付请求");
        const response = await this.$store.dispatch("order/pay", {
          order_id: this.order.id,
          payment_code: this.order.payment_code
        });
        this.$dialog.loading.close();
        if (!response) {
          this.$dialog.toast({ mes: "提交支付请求失败", icon: "error" });
          return;
        }
        const { code_url, pay_status, redirect_url, pay_request } = response;

        if (pay_status == "PAID") {
          this.order.pay_status = pay_status;
          this.$dialog.toast({ mes: "支付成功", icon: "success" });
          return;
        }
        if (
          window.navigator.userAgent.match(
            /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
          )
        ) {
          if (window.WeixinJSBridge) {
            WeixinJSBridge.invoke("getBrandWCPayRequest", pay_request, res => {
              if (res.err_msg == "get_brand_wcpay_request:ok") {
                this.checkPay();
              } else if (res.err_msg != "get_brand_wcpay_request:cancel") {
                alert(res.err_msg);
              }
            });
            return;
          } else {
          }
        }

        if (redirect_url) {
          location.href = redirect_url;
          return;
        }
        this.codeUrl = code_url;
        this.showPayDialog = true;
      } catch (error) {
        this.$dialog.loading.close();
        this.$dialog.toast({ mes: "提交支付请求失败", icon: "error" });
        this.$errorHandle(error);
      }
    },

    async showShipping() {
      const shippingStatus = await this.$store.dispatch(
        "order/getShippingStatus",
        this.order.id
      );

      if (shippingStatus.status == 200) {
        shippingStatus.msg.context = shippingStatus.msg.context.map(o => {
          return {
            time: moment(o.time * 1000).format("YYYY-MM-DD HH:mm:ss"),
            desc: o.desc
          };
        });
      }
      this.displayShpping = true;
      this.shippingStatus = shippingStatus;
    },

    async checkPay() {
      this.showPayDialog = false;
      this.$dialog.loading.open("正在校验支付结果");

      if (this.checkInterval) {
        clearInterval(this.checkInterval);
      }

      this.checkTimes = 0;
      this.checkInterval = setInterval(async () => {
        this.checkTimes++;
        if (this.checkTimes >= 15 && this.checkInterval) {
          clearInterval(this.checkInterval);
          this.checkTimes = 0;
          this.checkInterval = null;
          if (this.order.pay_status != "PAID") {
            this.$dialog.loading.close();
            this.$dialog.toast({
              mes: "未获取到支付结果，请稍后刷新再试",
              icon: "error"
            });
          }
          return;
        }

        const order = await this.$store.dispatch(
          "order/getOrder",
          this.order.id
        );

        if (order.pay_status == "PAID") {
          this.order.pay_status = order.pay_status;
          this.$dialog.loading.close();
          this.$dialog.toast({ mes: "支付成功", icon: "success" });
          if (this.checkInterval) {
            clearInterval(this.checkInterval);
            this.checkTimes = 0;
            this.checkInterval = null;
          }
        }
      }, 1000);
    },

    async changeComment() {
      
      const order = await this.$store.dispatch(
        "order/updateOrder",
        { id: this.order.id, comment: this.order.comment }
      );

      this.$dialog.alert({
          mes: "您的订单备注修改成功"
      });

      this.displayChangeComment = false;
    }
  },

  async mounted() {
    const { id, pay } = this.$router.currentRoute.query;
    if (!id) {
      return this.errorBack();
    }
    this.$dialog.loading.open("加载中");
    const order = await this.$store.dispatch("order/getOrder", id);
    if (!order) {
      this.$dialog.loading.close();
      return this.errorBack();
    }
    this.order = order;

    this.$dialog.loading.close();

    if (pay) {
      this.tapPay();
    }
  }
};
</script>
